import React from "react";
import { t } from "../../i18n";
import { FaSyringe, FaHandHoldingMedical, FaStethoscope, FaXRay, FaWalking, FaCut } from "react-icons/fa";
import "./TreatmentGrid.css";

const treatments = [
  { icon: FaStethoscope, title: "Initial Evaluation", desc: "Comprehensive assessment of your condition" },
  { icon: FaXRay, title: "Diagnostic Imaging", desc: "MRI, X-ray, and advanced imaging services" },
  { icon: FaSyringe, title: "Injection Therapy", desc: "Pain-relieving injections and treatments" },
  { icon: FaWalking, title: "Physical Therapy", desc: "Rehabilitation and strength training" },
  { icon: FaHandHoldingMedical, title: "Conservative Care", desc: "Non-surgical treatment options" },
  { icon: FaCut, title: "Surgical Options", desc: "Minimally invasive procedures when needed" },
];

export default function TreatmentGrid({ service, locale = "en" }) {
  return (
    <section className="treatment-grid">
      <div className="container">
        <h2>{t("section.treatmentOptions", locale)}</h2>
        <div className="tg-grid">
          {treatments.map((tx, i) => (
            <div key={i} className="tg-card">
              <tx.icon className="tg-icon" />
              <h3>{tx.title}</h3>
              <p>{tx.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
